import React, { useRef, useState } from 'react';
import Cropper from 'react-cropper';
import Skeleton from '@mui/material/Skeleton';
import Button from '@mui/material/Button';

import 'cropperjs/dist/cropper.css';

export default function PreviewImage({
  src,
  getCroppedFile,
  handleClose,
  originalImageFile,
}) {
  const cropperRef = useRef(null);
  const [loading, setLoading] = useState(true);

  const handleCrop = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;

    if (!cropper || !originalImageFile) return;

    const originalType = originalImageFile.type || 'image/jpeg';
    const extension = originalType.split('/')[1] || 'jpg';

    cropper.getCroppedCanvas().toBlob((blob) => {
      if (!blob) return;

      const nameParts = originalImageFile.name.split('.');
      nameParts[nameParts.length - 1] = extension;
      const finalName = nameParts.join('.');

      const file = new File([blob], finalName, { type: originalType });

      getCroppedFile(file);

      if (handleClose) handleClose();
    }, originalType);
  };

  return (
    <>
      {loading && <Skeleton variant="rectangular" width="100%" height={400} />}

      <Cropper
        src={src}
        ready={() => {
          setLoading(false);
        }}
        ref={cropperRef}
        style={{ height: 650, width: '100%' }}
        initialAspectRatio={1}
        viewMode={1}
        guides={true}
        minCropBoxHeight={10}
        minCropBoxWidth={10}
        background={false}
        responsive={true}
        checkOrientation={false}
      />

      <Button
        sx={{
          float: 'right',
          mt: 1,
          fontFamily: 'poppins',
          backgroundColor: '#6C2AD2',
          color: 'white',
          ':hover': {
            backgroundColor: '#6C2AD2',
            color: 'white',
          },
        }}
        onClick={handleCrop}
        color="success"
        variant="contained"
      >
        Crop
      </Button>
    </>
  );
}
